import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { InformesService } from 'app/services/informes.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-pasar-apoyo',
  templateUrl: './pasar-apoyo.component.html',
  styleUrls: ['./pasar-apoyo.component.scss']
})
export class PasarApoyoComponent implements OnInit {  

  selEduCro: string [] = ['Educación', 'Cronicidad', 'Otros'];
  prioridad: number [] = [0,1,2,3,4,5,6,7,8,9];

  public SelEduCro: string;
  public notas: string;
  public Prioridad: string;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private _informe:InformesService, private _snackBar: MatSnackBar, private dialogRef: MatDialogRef<PasarApoyoComponent>) { }

  ngOnInit() {
  }

  public guardarBeneficiario(){
    let notasIngresoAp: string = this.SelEduCro+"\n"+this.notas;
    
    this._informe.GuardarBeneficiario(this.datos.document, notasIngresoAp, this.Prioridad).subscribe((data:any) => {
      if(data.estatus == 1){
        this._snackBar.open('Se ha guardado el beneficiario', 'Aceptar', {
          duration: 2000,
        });   
        this.dialogRef.close(true);
      }else if(data.estatus == 0){
        this._snackBar.open('Error al actualizar beneficiario', 'Aceptar', {
          duration: 2000,
        })
      }
    });
  }  
}

